var getProductUrl = function getProductUrl(baseFinancialServiceUrl, productSku, subOrderUUID) {
  return "".concat(baseFinancialServiceUrl, "&sku=").concat(productSku, "&subOrderUUID=").concat(subOrderUUID);
};
export default getProductUrl;